// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tltyWuJxKaNBD30wryrc {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  font-family: var(--curio-font-family);
}

/* The node's category, in the node's category colour — the same palette the
   canvas paints its left border with. This was a single flat peach for every
   category, so the pill named the category while the border beside it was the
   only thing that showed it. */
.F4E_DB9R85cAF4lWR0S2 {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--curio-category-package-on-tint);
  background-color: var(--curio-category-package-bg);
  padding: 2px 8px;
  border-radius: var(--curio-radius-pill);
  line-height: 1.15;
  white-space: nowrap;
}

.edLlGHCGibAyj1TI1cNb {
  color: var(--curio-category-data-on-tint);
  background-color: var(--curio-category-data-bg);
}

.iHYlz7JeOPdlIOOMZDf7 {
  color: var(--curio-category-computation-on-tint);
  background-color: var(--curio-category-computation-bg);
}

.wJ5m5ytEGQoK9YxX5Ecb {
  color: var(--curio-category-vis-on-tint);
  background-color: var(--curio-category-vis-bg);
}

.p3w4hilQagly6vNkT3rp {
  color: var(--curio-category-package-on-tint);
  background-color: var(--curio-category-package-bg);
}

.G2P1gB0hzG6W0hRlW3mZ {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--curio-role-published-fg);
  background-color: var(--curio-role-published-bg);
  border: 1px solid rgba(53, 103, 199, 0.4);
  border-radius: var(--curio-radius-pill);
  padding: 2px 8px;
  line-height: 1.15;
  white-space: nowrap;
  cursor: pointer;
  font-family: inherit;
}

.G2P1gB0hzG6W0hRlW3mZ:hover {
  background-color: rgba(53, 103, 199, 0.25);
  border-color: var(--curio-role-published-fg);
}

.G2P1gB0hzG6W0hRlW3mZ:focus-visible {
  outline: 2px solid var(--curio-role-published-fg);
  outline-offset: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/editing/PackageMetaHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qCAAqC;AACvC;;AAEA;;;+BAG+B;AAC/B;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;EAC5C,kDAAkD;EAClD,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;EAChD,sDAAsD;AACxD;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,gDAAgD;EAChD,yCAAyC;EACzC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB","sourcesContent":[".pills {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  font-family: var(--curio-font-family);\n}\n\n/* The node's category, in the node's category colour — the same palette the\n   canvas paints its left border with. This was a single flat peach for every\n   category, so the pill named the category while the border beside it was the\n   only thing that showed it. */\n.categoryBadge {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--curio-category-package-on-tint);\n  background-color: var(--curio-category-package-bg);\n  padding: 2px 8px;\n  border-radius: var(--curio-radius-pill);\n  line-height: 1.15;\n  white-space: nowrap;\n}\n\n.categoryBadge_data {\n  color: var(--curio-category-data-on-tint);\n  background-color: var(--curio-category-data-bg);\n}\n\n.categoryBadge_computation {\n  color: var(--curio-category-computation-on-tint);\n  background-color: var(--curio-category-computation-bg);\n}\n\n.categoryBadge_vis {\n  color: var(--curio-category-vis-on-tint);\n  background-color: var(--curio-category-vis-bg);\n}\n\n.categoryBadge_package {\n  color: var(--curio-category-package-on-tint);\n  background-color: var(--curio-category-package-bg);\n}\n\n.packageBadge {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--curio-role-published-fg);\n  background-color: var(--curio-role-published-bg);\n  border: 1px solid rgba(53, 103, 199, 0.4);\n  border-radius: var(--curio-radius-pill);\n  padding: 2px 8px;\n  line-height: 1.15;\n  white-space: nowrap;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.packageBadge:hover {\n  background-color: rgba(53, 103, 199, 0.25);\n  border-color: var(--curio-role-published-fg);\n}\n\n.packageBadge:focus-visible {\n  outline: 2px solid var(--curio-role-published-fg);\n  outline-offset: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pills": `tltyWuJxKaNBD30wryrc`,
	"categoryBadge": `F4E_DB9R85cAF4lWR0S2`,
	"categoryBadge_data": `edLlGHCGibAyj1TI1cNb`,
	"categoryBadge_computation": `iHYlz7JeOPdlIOOMZDf7`,
	"categoryBadge_vis": `wJ5m5ytEGQoK9YxX5Ecb`,
	"categoryBadge_package": `p3w4hilQagly6vNkT3rp`,
	"packageBadge": `G2P1gB0hzG6W0hRlW3mZ`
};
export default ___CSS_LOADER_EXPORT___;
